import React from 'react'
import Router from 'live/services/router'

/**
 *  @param path The route name
    @param component The component that will be rendered
    @param alias The alias, has to match with the menu alias
    @param extra An extra record to apply
 */
export const addRoute = (
    path: string,
    Component: React.ComponentType,
    alias: string,
    extra?: Record<string, unknown>
): void => {
    const route = (url, extra?: Record<string, unknown>): void =>
        Router.route(url, Component as never, alias, { hideFooter: true, ...extra })

    route(`${path}`, extra)
    route(`${path}?{query}`, extra)
}
